// extracted by mini-css-extract-plugin
module.exports = {"container":"text-checker_container__c8w5o","signupCta":"text-checker_signupCta__OWMyG"};